/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_TimezoneInputs */



/**
* | output |
* | --- |
* | "Timezone" |
*
* @param {Tfield_TimezoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_timezone = /** @type {((inputs?: Tfield_TimezoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_TimezoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fuseau horaire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Zona horaria")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fuso Horário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fuso Orario")
	return /** @type {LocalizedString} */ ("Timezone")
});